module.exports = __webpack_public_path__ + "nk.f3464e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/mocks/nk.png
// module id = 2385
// module chunks = 0